import React from "react";
import "./MobileHeaderDropdown.scss";
import { LeftOutlined, NodeIndexOutlined } from "@ant-design/icons";

export interface MobileSolutionsDropdownProps {
  toggleSolutions: (ev: React.MouseEvent) => void;
}

export default function MobileSolutionsDropdown({ toggleSolutions } : MobileSolutionsDropdownProps) {
  return (
      <ul className={"drawer-nav"}>
        <li className="header" onClick={(ev: any) => toggleSolutions(ev)}>
          <LeftOutlined/>
          <span>Solutions</span>
        </li>
        <li>
          <a href="/feature/digital-menu-board-solution.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/DSABlack.svg" alt="digial signage"/>
            <span>Digital Signage</span>
          </a>
        </li>
        <li>
          <a href="/feature/easy-menu-design-for-restaurants.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/PaintbrushIcon.svg" alt="menu designer"/>
            <span>Menu Designer</span>
          </a>
        </li>
        <li>
          <a href="/feature/menu-services.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/CustomerService.svg" alt="menu services"/>
            <span>Menu Services</span>
          </a>
        </li>
        <li>
          <a href="/feature/Print-Services.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/Printer.svg" alt="print services"/>
            <span>Print Services</span>
          </a>
        </li>
        <li>
          <a href="/feature/restaurant-menu-management.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/MenuManagement.svg" alt="menu management"/>
            <span>Menu Management Software</span>
          </a>
        </li>
        <li>
          <a href="/content/toast-partner-connect">
            <NodeIndexOutlined/>
            <span>POS Integration</span>
          </a>
        </li>
        <li>
          <a href="/feature/online-menu.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/OnlineMenus.svg" alt="ordering menus"/>
            <span>Ordering Menus</span>
          </a>
        </li>
        <li>
          <a href="/feature/menu-qr-code.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/QRCode.svg" alt="qr menus"/>
            <span>QR Menus</span>
          </a>
        </li>
        <li>
          <a href="/feature/restaurant-landing-pages.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/MegaphoneFilled.svg" alt="link pages"/>
            <span>Link Pages</span>
          </a>
        </li>
      </ul>
  )
}